// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default class MinecraftLogItem {
  fileName: string | undefined;
  message: string | undefined;
}
